import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../css/cover.css';
import '../../css/styles.css';
import { useParams } from 'react-router-dom';
import api from "../../api";
import DeleteIcon from '@material-ui/icons/Delete';
import { toast, ToastContainer } from "react-toastify";
import AddIcon from "@mui/icons-material/Add";
import VectorImage from "../../assets/images/vector-image.png";
import AttachmentIcon from "../../assets/images/attachment.png";
import LoadingSpinner from "../Loading";

function Album() {
    const [beforeAlbums, setBeforeAlbums] = useState([]);
    const [afterAlbums, setAfterAlbums] = useState([]);
    const [file, setFile] = useState(null);
    const [isHovering, setIsHovering] = useState(false);
    const [report, setReport] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const handleDeleteClick = (albumId) => {
        api.delete(`/album/${albumId}`)
            .then(response => {
                console.log(response)
                window.location.reload();
            })
            .catch(error => {
                console.log(error)
                toast.error(error.response.data.message)
            });
    };

    const { reportId } = useParams();

    useEffect(() => {
        async function fetchReport() {
            const response = await api.get(`/repair-request/${reportId}`);
            setReport(response.data.data);
        }

        fetchReport();

        const fetchAlbums = async () => {
            try {
                api.get(`/repair-request/${reportId}`)
                    .then(res => {
                        const report = res.data.data;
                        report.albums.map(album => {
                            if (album.type === 1) {
                                setBeforeAlbums(prevItems => [...prevItems, album])
                            } else {
                                setAfterAlbums(prevItems => [...prevItems, album])
                            }
                        })
                        // setError(res.data.message);
                    })
                    .catch(err => {
                        toast.error(err.response.data.message);
                        setBeforeAlbums([]);
                        setAfterAlbums([]);
                    });
            } catch (error) {
                toast.error(error.response.data.message)
            }
        };
        fetchAlbums();
    }, [])

    const handleFileSelect = (e) => {
        if (e.target.files) {
            setFile(e.target.files[0]);
        }
    };

    const handleBeforeImageUpload = async () => {
        if (!file) {
            return;
        }
        setIsLoading(true);
        const formData = new FormData();
        formData.append('url', file);
        formData.append('type', 1);
        formData.append('content_type', 2);
        formData.append('repair_request_id', reportId);
        try {
            await api.post('/album', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(res => {
                    const newAlbum = res.data;
                    setBeforeAlbums([...beforeAlbums, newAlbum]);
                    window.location.reload();
                });
        } catch (error) {
            toast.error(error.response.data.message)
        } finally {
            setIsLoading(false);
        }
    };

    const handleAfterImageUpload = async () => {
        if (!file) {
            return;
        }
        setIsLoading(true);
        const formData = new FormData();
        formData.append('url', file);
        formData.append('type', 2);
        formData.append('content_type', 2);
        formData.append('repair_request_id', reportId);
        try {
            await api.post('/album', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(res => {
                    const newAlbum = res.data;
                    setAfterAlbums([...afterAlbums, newAlbum]);
                    window.location.reload();
                })

        } catch (error) {
            toast.error(error.response.data.message)
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div>
            {isLoading ? <LoadingSpinner /> :
                <div className="content-wrapper">
                    <div className="container-xxl flex-grow-1 container-p-y">
                        <div className="row justify-content-center">
                            <div className="col-12 col-sm-12 col-md-8 col-lg-6 col-xl-6 col-xxl-6">
                                <div className="card border-3 rounded-4 border-dark mb-4">
                                    <h5 className="card-header bg-dark text-center text-white fw-bold">آلبوم تصاویر قبل
                                        از
                                        تعمیرات</h5>
                                    <div className="card-body">
                                        {report && (
                                            <div>
                                                {report.status !== 4 && (
                                                    <div>
                                                        <label htmlFor="before-image-input"
                                                            className="card btn justify-content-center shadow"
                                                            style={{ height: '8rem' }}>
                                                            <div className="d-flex justify-content-center">
                                                                <img src={AttachmentIcon} alt="attachment"
                                                                    style={{ height: '25px', width: '25px' }} />
                                                                <div className="me-2 my-auto">انتخاب تصویر موردنظر</div>
                                                            </div>
                                                        </label>
                                                        <input
                                                            type="file"
                                                            id="before-image-input"
                                                            className='form-control'
                                                            onChange={handleFileSelect}
                                                            style={{ visibility: "hidden" }}
                                                            accept='image/*'
                                                        />
                                                        <div className='mt-2'>
                                                            {file && `${file.name} - ${file.type}`}
                                                            <button onClick={handleBeforeImageUpload}
                                                                className="btn btn-warning w-100">
                                                                <AddIcon />اضافه کردن
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                        <div className="d-flex flex-wrap">
                                            {[...Array(4)].map((_, index) => {
                                                const beforeAlbum = beforeAlbums[index];
                                                return (
                                                    <div
                                                        key={index}
                                                        className="col"
                                                        onMouseEnter={() => setIsHovering(true)}
                                                        onMouseLeave={() => setIsHovering(false)}
                                                        style={{ position: "relative" }}
                                                    >
                                                        {beforeAlbum ? (
                                                            <img
                                                                src={beforeAlbum.url}
                                                                alt=""
                                                                className="mt-2 rounded-2 px-1"
                                                                style={{
                                                                    width: "100%",
                                                                    height: "10vh",
                                                                    objectFit: "cover"
                                                                }}
                                                            />
                                                        ) : (
                                                            <img
                                                                src={VectorImage}
                                                                alt=""
                                                                className="mt-2"
                                                                style={{
                                                                    width: "100%",
                                                                    height: "10vh",
                                                                    objectFit: "cover"
                                                                }}
                                                            />
                                                        )}
                                                        {isHovering && beforeAlbum && (
                                                            <div
                                                                style={{
                                                                    position: "absolute",
                                                                    top: "50%",
                                                                    left: "50%",
                                                                    transform: "translate(-50%, -50%)",
                                                                    cursor: "pointer",
                                                                    background: "rgba(0, 0, 0, 0.5)",
                                                                    borderRadius: "50%",
                                                                    padding: "10px",
                                                                }}
                                                                onClick={() => handleDeleteClick(beforeAlbum.id)}
                                                            >
                                                                <DeleteIcon style={{ color: "white" }} />
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                    <h5 className="card-header bg-dark text-center text-white fw-bold">آلبوم تصاویر بعد
                                        از
                                        تعمیرات</h5>
                                    <div className="card-body">
                                        {report &&
                                            <div>
                                                {report.status !== 4 &&
                                                    <div>
                                                        <label htmlFor="after-image-input"
                                                            className="card btn justify-content-center shadow"
                                                            style={{ height: '8rem' }}>
                                                            <div className="d-flex justify-content-center">
                                                                <img src={AttachmentIcon} alt="attachment"
                                                                    style={{ height: '25px', width: '25px' }} />
                                                                <div className="me-2 my-auto">انتخاب تصویر موردنظر</div>
                                                            </div>
                                                        </label>
                                                        <input
                                                            type="file"
                                                            id="after-image-input"
                                                            className='form-control'
                                                            onChange={handleFileSelect}
                                                            style={{ visibility: "hidden" }}
                                                            accept='image/*'
                                                        />
                                                        <div className='mt-2'>{file && `${file.name} - ${file.type}`}
                                                            <button onClick={handleAfterImageUpload}
                                                                className='btn btn-success w-100'>
                                                                <AddIcon />اضافه کردن
                                                            </button>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        }
                                        <div className="d-flex flex-wrap">
                                            {[...Array(4)].map((_, index) => {
                                                const afterAlbum = afterAlbums[index];
                                                return (
                                                    <div
                                                        key={index}
                                                        className="col"
                                                        onMouseEnter={() => setIsHovering(true)}
                                                        onMouseLeave={() => setIsHovering(false)}
                                                        style={{ position: "relative" }}
                                                    >
                                                        {afterAlbum ? (
                                                            <img
                                                                src={afterAlbum.url}
                                                                alt=""
                                                                className="mt-2 rounded-2 px-1"
                                                                style={{
                                                                    width: "100%",
                                                                    height: "10vh",
                                                                    objectFit: "cover"
                                                                }}
                                                            />
                                                        ) : (
                                                            <img
                                                                src={VectorImage}
                                                                alt=""
                                                                className="mt-2"
                                                                style={{
                                                                    width: "100%",
                                                                    height: "10vh",
                                                                    objectFit: "cover"
                                                                }}
                                                            />
                                                        )}
                                                        {isHovering && afterAlbum && (
                                                            <div
                                                                style={{
                                                                    position: "absolute",
                                                                    top: "50%",
                                                                    left: "50%",
                                                                    transform: "translate(-50%, -50%)",
                                                                    cursor: "pointer",
                                                                    background: "rgba(0, 0, 0, 0.5)",
                                                                    borderRadius: "50%",
                                                                    padding: "10px",
                                                                }}
                                                                onClick={() => handleDeleteClick(afterAlbum.id)}
                                                            >
                                                                <DeleteIcon style={{ color: "white" }} />
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default Album;
